<template>
  <div class="row">
    <div class="col-md-12">
      <div class="progress-template">
        <i class="bi bi-gear" style="font-size: 100px"></i>
        <h2>Development In Progress</h2>
      </div>
    </div>
  </div>
</template>

<style scoped>
.progress-template {
  padding: 40px 15px;
  text-align: center;
}
</style>
